import Modal from 'components/Modal';
import Typography from 'components/Typography';
import styles from './AddressListModal.module.scss';
import {Key} from 'react';
import Button from 'components/Button';
import {Address} from 'types';
interface AddressListModalProps {
  isOpen: boolean;
  onClose: () => void;
  addresses: Address[];
  deliveryAddressId: number;
  setDeliveryAddressId: (id: number) => void;
  openNewAddressModal: () => void;
  addressIsUpdating: boolean;
  addressChangeHandler: (id: number) => void;
}

function AddressListModal({
  isOpen,
  onClose,
  addresses,
  deliveryAddressId,
  setDeliveryAddressId,
  openNewAddressModal,
  addressIsUpdating,
  addressChangeHandler,
}: AddressListModalProps) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} className={styles.list_wrapper}>
      <Typography component="p" className={styles.modalDesc} variant="h2">
        Select Delivery Address:
      </Typography>
      <div className={styles.optionWrapper}>
        {addresses.map((item: Address, index: Key | null | undefined) => {
          return (
            <label key={index} className={styles.container}>
              <input
                type="radio"
                name="radio"
                defaultChecked={deliveryAddressId === item.id}
                onClick={() => setDeliveryAddressId(item.id)}
              />
              <span className={styles.radioButtonText}>
                {item.display_address}
              </span>
              {!item.is_valid && (
                <span className={styles.wrongAddress}>issue</span>
              )}
            </label>
          );
        })}
        <div onClick={openNewAddressModal} className={styles.addAddress}>
          + Add address
        </div>
      </div>
      <div className={styles.actions}>
        <Button
          type="submit"
          onClick={() => addressChangeHandler(deliveryAddressId || 0)}
          size="md"
          loading={addressIsUpdating}
        >
          Submit
        </Button>
      </div>
    </Modal>
  );
}
export default AddressListModal;
